import React, { useState } from 'react';
import 'antd/dist/antd.css';
import { Avatar, Button, Card, Form, Input, Modal, Checkbox } from 'antd';
import '../chatComponent/chat.css';
import { sendMessagePersonal, createGroupChat } from '../api/api';
const { Meta } = Card;
const CreatePersonalGroupChatModal = ({ props }: any) => {
  // Активность модалки доб. личного чата
  const [isUsersModal, setIsUsersModal] = useState(false);
  const [sessionPersonal, setSessionPersonal] = useState([]);
  //Создание группового чата
  const [isGroupModal, setIsGroupModal] = useState(false);
  //для значений сообщения и документов
  const [nameGroupform] = Form.useForm();

  // const propsTakeFromChat = useMemo(() => {
  //   // console.log('CreatePersonalGroupChatModal', props);
  //   if (props !== undefined) {
  //     setSessionPersonal(props.sessionPersonal);
  //   }
  // }, [props]);

  const openUsersModal = () => {
    setIsUsersModal(true);
  };
  const newChat = (id: any) => {
    const existSession: any = sessionPersonal.find(
      (item: any) => item.user_id === id || item.receiver_id === id
    );
    //Если чат существует открыть его, если нет создаем его
    if (existSession) {
      props.openPersonal({
        session_id: existSession.receiver_id,
      });
    } else {
      sendMessagePersonal({ content: 'Этот пользователь создал с вами чат', receiver_id: id }).then(
        () => {
          props.resetUseEffect();
        }
      );
    }

    setIsUsersModal(false);
  };
  // const openGroupModal = () => {
  //   setIsGroupModal(true);
  // };
  // сброс состояния модального группового окна
  const resetStateFromModalGroup = () => {
    props.resetStateFromModalGroup();
    nameGroupform.resetFields();
    setIsGroupModal(false);
    props.resetStateFromModalGroup();
  };

  //Создание новой группы РАЗРАБОТКА
  const newGroup = (e: any) => {
    if (e.groupName === '' || e.groupName === undefined) {
      alert('Введите название беседы');
    } else {
      if (props.groupCreateData.user_id.length <= 0) {
        alert('Выберите больше 1-го пользователя');
      } else {
        props.groupCreateData.group_name = e.groupName;

        createGroupChat(props.groupCreateData).then((res) => {
          // console.log('Группа создана', res);
        });
        props.resetUseEffect();
        resetStateFromModalGroup();
      }
    }
  };
  return (
    <>
      {/* <Button onClick={openGroupModal}>Создать Группу</Button> */}
      <Button type="default" className="button__new-chat" onClick={openUsersModal}>
        Создать Чат
      </Button>
      <Modal
        key={'UsersModal'}
        title="Личный чат"
        open={isUsersModal}
        onCancel={() => {
          setIsUsersModal(false);
        }}
      >
        {props?.allUsers?.map((item: any) => {
          return (
            <div
              key={item.id + 'div'}
              className="modal_users"
              onClick={() => {
                newChat(item.id);
              }}
            >
              <Meta
                avatar={<Avatar src={item.image} />}
                title={item.name}
                // description={'sdf'}
                key={item.id + 'key'}
              />
            </div>
          );
        })}
      </Modal>
      <Modal
        key={'GroupModal'}
        title="Групповой чат"
        open={isGroupModal}
        onOk={nameGroupform.submit}
        onCancel={resetStateFromModalGroup}
      >
        <Form key={'GroupModal'} onFinish={newGroup} form={nameGroupform} name="nameGroup">
          <Form.Item label="Название группы" name="groupName">
            <Input />
          </Form.Item>

          {props?.allUsers?.map((item: any) => {
            return (
              <div key={item.id + 'GroupDiv'} className="modal_users">
                <Meta
                  avatar={<Avatar src={item.image} />}
                  title={item.name}
                  // description={'sdf'}
                  key={item.id + 'Groupkey'}
                />
                <Form.Item
                  key={'Not_important_key' + item.id}
                  name={'Not_important' + item.id}
                  valuePropName={'checked' + item.id}
                >
                  <Checkbox
                    key={'GroupCheckbox' + item.id}
                    onChange={(e) => {
                      props.usersArrayFunc(item.id, e.target.checked);
                    }}
                  ></Checkbox>
                </Form.Item>
              </div>
            );
          })}
        </Form>
      </Modal>
    </>
  );
};

export default CreatePersonalGroupChatModal;
